import api from "./index";

/**
 * Access & Permissions API.
 * Powers the admin-only "Access & Permissions" page: the live roster of CRM
 * staff grouped by access level. Read-only, admin-gated on the backend.
 */

// GET staff users grouped by role.
export const getAccessOverview = () =>
  api.get("role-management/access-overview/");
